"use strict";

(function ($) {
  $.fn.languagesForm = function () {
    var langs = $('.js-lawyer-lang');
    var arrLang = [];
    langs.each(function () {
      arrLang.push($(this).attr('id'));
    });

    for (var i = 0; i < arrLang.length; i++) {
      $('.js-language').each(function () {
        if ($(this).attr('id') == arrLang[i]) {
          $(this).prop('checked', true);
        }
      });
    }
  };
})(jQuery);